import { FilterConfig } from "../../../models/FilterConfig";
import { LineofBusiness } from "../../../models/LineofBusinessFilterData";

export const PriceMarginWaterfallFilterConfig: Record<
  LineofBusiness,
  FilterConfig[]
> = {
  electrical: [
    {
      apiKey: "project",
      filterLabelKey: "project_flag",
      filterValueKey: "project_flag",
      filterName: "Project",
      type: "single",
      payloadValuekey: "project",
    },
    {
      apiKey: "district",
      filterLabelKey: "district",
      filterValueKey: "district",
      filterName: "District",
      type: "single",
      payloadValuekey: "district",
    },
    {
      apiKey: "vendor",
      filterLabelKey: "vendor_name",
      filterValueKey: "vendor_name",
      filterName: "Vendor",
      type: "single",
      payloadValuekey: "vendor",
    },
    {
      apiKey: "customerClass",
      filterLabelKey: "customerclass",
      filterValueKey: "customerclass",
      filterName: "Customer Class",
      type: "single",
      payloadValuekey: "customerClass",
    },
    {
      apiKey: "customer",
      filterLabelKey: "id",
      filterValueKey: "id",
      filterName: "Customers",
      type: "single",
      payloadValuekey: "customer",
    },
    {
      apiKey: "l1",
      filterLabelKey: "L1",
      filterValueKey: "L1",
      filterName: "L1",
      type: "single",
      payloadValuekey: "l1",
    },
    {
      apiKey: "l2",
      filterLabelKey: "L2",
      filterValueKey: "L2",
      filterName: "L2",
      type: "single",
      payloadValuekey: "l2",
    },
    {
      apiKey: "l3",
      filterLabelKey: "L3",
      filterValueKey: "L3",
      filterName: "L3",
      type: "single",
      payloadValuekey: "l3",
    },
  ],
  plumbing: [
    {
      apiKey: "pc",
      filterLabelKey: "PC",
      filterValueKey: "PC",
      filterName: "PCs",
      type: "single",
      payloadValuekey: "pc",
    },
    {
      apiKey: "directId",
      filterLabelKey: "sales_order_direct_id",
      filterValueKey: "sales_order_direct_id",
      filterName: "Direct Freight",
      type: "single",
      payloadValuekey: "directId",
    },
    {
      apiKey: "modes",
      filterLabelKey: "mode",
      filterValueKey: "mode",
      filterName: "Mode",
      type: "single",
      payloadValuekey: "mode",
    },
    {
      apiKey: "HomeFilter",
      filterLabelKey: "Home_NonHome_Flag",
      filterValueKey: "Home_NonHome_Flag",
      filterName: "Home Flag",
      type: "single",
      payloadValuekey: "homeFlag",
    },
    {
      apiKey: "customerClass",
      filterLabelKey: "customerClass",
      filterValueKey: "customerClass",
      filterName: "Customer Class",
      type: "single",
      payloadValuekey: "customerClass",
    },
    {
      apiKey: "customer",
      filterLabelKey: "id",
      filterValueKey: "id",
      filterName: "Customers",
      type: "single",
      payloadValuekey: "customerDesc",
    },
    {
      apiKey: "VMI_Flag",
      filterLabelKey: "VMI_Flag",
      filterValueKey: "VMI_Flag",
      filterName: "VMI Flag",
      type: "single",
      payloadValuekey: "VMI_Flag",
    },
    {
      apiKey: "vendor",
      filterLabelKey: "vendor",
      filterValueKey: "vendor",
      filterName: "Vendors",
      type: "single",
      payloadValuekey: "vendor",
    },
    {
      apiKey: "productId",
      filterLabelKey: "productDescription",
      filterValueKey: "product_id",
      filterName: "Product Desc",
      type: "single",
      payloadValuekey: "productId",
    },
    {
      apiKey: "UPC",
      filterLabelKey: "UPC",
      filterValueKey: "UPC",
      filterName: "UPC",
      type: "single",
      payloadValuekey: "UPC",
    },
    {
      apiKey: "priceIds",
      filterLabelKey: "ErpPriceLineId",
      filterValueKey: "ErpPriceLineId",
      filterName: "Price Line id",
      type: "single",
      payloadValuekey: "priceIds",
    },
  ],
};
